export const QUERY_KEYS = {
  DATASETS_LIST: 'datasets-list',
  DATASET_DETAIL: 'dataset-detail',
  DATASET_FILES: 'dataset-files',
  MISSED_DATASETS: 'missed-datasets',
  MISSED_DATASETS_RUNTIME: 'missed-datasets-runtime',
  DATA_INGESTORS_LIST: 'data-ingestors-list',
  DATA_INGESTOR_DETAIL: 'data-ingestor-detail',
  CUSTOM_CULTURE_STATUS_LIST: 'custom-culture-status-list',
  WELL_PAGE: 'well-page',
  CULTURE_LINEAGE: 'culture-lineage',
  REPRESENTATIVE_IMAGES: 'representative-images',
  PLATE_PAGE: 'plate-page',
  CULTURES_PAGE: 'cultures-page',
  CULTURE_PAGE_LIST: 'culture-page-list',
  CULTURE_PAGE_FILTER_DEFINITIONS: 'culture-page-filter-definitions',
  CULTURE_PAGE_CULTURE_FILTER_DEFINITIONS: 'culture-page-culture-filter-definitions',
  CULTURE_PAGE_BULK_EXPORT: 'culture-page-bulk-export',
  STITCHED_MONTAGE: 'stitched_montage',
  SERVER_STITCHED_IMAGE: 'server-stitched-image',
  BLOB_IMAGES: 'blob-images',
  EXTRACTED_PLATE_SPRITE: 'extracted-plate-sprite',
  WORKFLOW_INSTANCES_ACTIVE: 'workflow-instances-active',
  WORKFLOW_INSTANCES_PENDING: 'workflow-instances-pending',
  WORKFLOW_PLANNED_ROUTINES: 'workflow-planned-routines',
} as const
